export default "__VITE_ASSET__BozGCHra__"